var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding" }, [
    _c(
      "h5",
      [
        _c("q-icon", { attrs: { name: "lock", color: "primary" } }),
        _vm._v(" Security ")
      ],
      1
    ),
    _vm.mode === "edit" && _vm.lastLogin
      ? _c("div", { staticClass: "row" }, [
          _c("p", [
            _vm._v(
              "Last Login: " + _vm._s(_vm.moment(_vm.lastLogin).format("llll"))
            )
          ])
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "sl-row" },
      [
        _vm.mode === "edit" && _vm.selectedUserId == _vm.loggedInUserId
          ? _c(
              "q-field",
              { staticClass: "q-pa-md" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Current Password",
                    type: "password",
                    "error-messages": _vm.passwordErrors,
                    value: _vm.changePasswordForm.currentPassword
                  },
                  on: {
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateChangePasswordForm({
                        field: "currentPassword",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md",
            attrs: {
              error: _vm.validation.changePasswordForm.password.$error,
              "error-label": "Length must be between 6 and 20 characters"
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Set Password",
                type: "password",
                "error-messages": _vm.passwordErrors,
                value: _vm.changePasswordForm.password,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateChangePasswordForm({
                    field: "password",
                    value: $event.target.value
                  })
                },
                input: function($event) {
                  _vm.validation.changePasswordForm.password.$touch()
                },
                blur: function($event) {
                  _vm.validation.changePasswordForm.password.$touch()
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md",
            attrs: {
              error: _vm.validation.changePasswordForm.confirmPassword.$error,
              "error-label": "Must match set password"
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Confirm Password",
                type: "password",
                "error-messages": _vm.confirmPasswordErrors,
                value: _vm.changePasswordForm.confirmPassword,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateChangePasswordForm({
                    field: "confirmPassword",
                    value: $event.target.value
                  })
                },
                input: function($event) {
                  _vm.validation.changePasswordForm.confirmPassword.$touch()
                },
                blur: function($event) {
                  _vm.validation.changePasswordForm.confirmPassword.$touch()
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }